var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290059 0.710022C-0.0999414 1.10002 -0.0999414 1.73002 0.290059 2.12002L4.17006 6.00002L0.290059 9.88002C-0.0999414 10.27 -0.0999414 10.9 0.290059 11.29C0.680059 11.68 1.31006 11.68 1.70006 11.29L6.29006 6.70002C6.68006 6.31002 6.68006 5.68002 6.29006 5.29002L1.70006 0.700022C1.32006 0.320022 0.680059 0.320022 0.290059 0.710022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.56b475a80e0a29535ab4347791ce104a.svg";
export { ForwardRef as ReactComponent };